import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pc: [],
    inventory: []
  },
  mutations: {
    setPC(state, data){
      state.pc = data;
    },
    setInventory(state, data){
      state.inventory = data;
    }
  },
  actions: {
    fetchPC({commit}){
      axios.get('/')
      .then(res=>commit('setPC', res.data))
      .catch()
    },
    fetchInventory({commit}){
      axios.get('/inventory')
      .then(res=>commit('setInventory', res.data))
      .catch()
    }
  }
})
